module.exports = __webpack_public_path__ + "img/productsPrimaryBackground.e134182.png";